
export const completeReport = "To be defined as PDF"

export default completeReport